import { useSelector, useDispatch } from "react-redux";
import update from "immutability-helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Snackbar, TextField } from "@material-ui/core";

import { getAllTransporters } from "../../reduxSaga/actions";
import { useEffect, useState, useRef } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import TransferService from "../../services/TransferBetweenWarehouses";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import PurchaseService from "../../services/PurchaseOrder";
import withLoader from "../../components/layouts/WithLoader";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: { color: "#000000" },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: { color: "#000000", zIndex: 1, fontSize: 18 },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;
  return (
    <div className={clsx(classes.root, { [classes.active]: active })}>
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = { active: PropTypes.bool, completed: PropTypes.bool };

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: { "& .MuiStepIcon-root.MuiStepIcon-active ": { color: "#000000" } },
  completed: { "& .MuiStepIcon-root.MuiStepIcon-completed": { color: "#000000" } },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;
  const icons = { 1: <SettingsIcon /> };
  return (
    <div className={clsx(classes.root, { [classes.active]: active, [classes.completed]: completed })}>
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = { active: PropTypes.bool, completed: PropTypes.bool, icon: PropTypes.node };

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": { width: "100%", color: "#000000" },
    "& .MuiStepIcon-root.MuiStepIcon-completed": { color: "#000000" },
  },
  button: { marginRight: theme.spacing(1) },
  instructions: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  icon: { color: "#000" },
}));

function getSteps() {
  return ["Informations", "Choisir les produits", "Finaliser"];
}

const EXCEL_TEMPLATE_HEADERS = ["Code à barre", "Quantité"];
const EXCEL_TEMPLATE_SAMPLE_ROW = ["6191500000015", 10];

const WarehouseTransfertExcel = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [infoAlertText, setInfoAlertText] = useState();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const [currentQteProductPurchase, setCurrentQteProductPurchase] = React.useState("nothing");
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseDestinationId, setWarehouseDestinationId] = useState(0);
  const [transportorId, setTransportorId] = useState(0);
  const [date, setDate] = React.useState("");
  const [transfertNote, setTransfertNote] = React.useState("");
  const [product, setProduct] = React.useState(0);
  const [qteWarehouseSource, setQteWarehouseSource] = React.useState("nothing");
  const [amount, setAmount] = React.useState(0);
  const [productTableData, setProductTableData] = React.useState([]);
  const [productMapById, setProductMapById] = React.useState([]);

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionTwo, setSelectedOptionTwo] = useState(null);
  const [selectedOptionThree, setSelectedOptionThree] = useState(null);
  const [selectedOptionProduct, setSelectedOptionProduct] = useState(null);
  const [allProducts, setAllProducts] = React.useState([{}]);

  const animatedComponents = makeAnimated();
  const animatedComponentsProduct = makeAnimated();

  const [allWarehouseSource, setAllWarehouseSource] = React.useState([{}]);
  const [allWarehouseDestination, setAllWarehouseDestination] = React.useState([{}]);
  const [allTransportors, setAllTransportors] = React.useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [warehousesDestination, setwarehousesDestination] = useState([]);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] = useState("Choisir...");

  // ── Excel / barcode import state ──────────────────────────────────────────
  const [barcodeTableData, setBarcodeTableData] = useState([]);
  const [excelFileName, setExcelFileName] = useState("");
  const [importMode, setImportMode] = useState("excel"); // "manual" | "excel"
  const fileInputRef = useRef(null);

  const transporteurs = useSelector((state) => state.staff.transporters.success);

  const handlerChangeQt = (event) => setAmount(event.target.value);

  const onDeleteProduct = (id) => {
    setProductTableData(productTableData.filter((item) => item.id !== id));
    setProductMapById(productMapById.filter((item) => item.id !== id));
  };

  const onDeleteBarcode = (codeABarre) => {
    setBarcodeTableData(barcodeTableData.filter((item) => item.codeABarre !== codeABarre));
  };

  // ── Excel template download ───────────────────────────────────────────────
  const onTelechargerModele = () => {
    try {
      const worksheet = XLSX.utils.aoa_to_sheet([
        EXCEL_TEMPLATE_HEADERS,
        EXCEL_TEMPLATE_SAMPLE_ROW,
      ]);
      worksheet["!cols"] = [{ wch: 22 }, { wch: 14 }];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Modele");
      const fileBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      saveAs(
        new Blob([fileBuffer], { type: "application/octet-stream" }),
        "modele_transfert_produits.xlsx"
      );
    } catch (err) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : impossible de générer le modèle Excel");
    }
  };

  // ── Excel parsing ─────────────────────────────────────────────────────────
  // const handleExcelUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   setExcelFileName(file.name);
  //   const reader = new FileReader();

  //   reader.onload = (e) => {
  //     try {
  //       const data = new Uint8Array(e.target.result);
  //       const workbook = XLSX.read(data, { type: "array" });
  //       const sheetName = workbook.SheetNames[0];
  //       const worksheet = workbook.Sheets[sheetName];

  //       // Convert sheet to array of arrays (raw values)
  //       const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: true });

  //       if (rows.length === 0) {
  //         setOpenErrorAlert(true);
  //         setErrorAlertText("Erreur : le fichier Excel est vide");
  //         return;
  //       }

  //       // Count occurrences of each barcode across all cells in all rows
  //       const barcodeCount = {};
  //       rows.forEach((row) => {
  //         row.forEach((cell) => {
  //           if (cell !== null && cell !== undefined && cell !== "") {
  //             const code = String(cell).trim();
  //             if (code) {
  //               barcodeCount[code] = (barcodeCount[code] || 0) + 1;
  //             }
  //           }
  //         });
  //       });

  //       if (Object.keys(barcodeCount).length === 0) {
  //         setOpenErrorAlert(true);
  //         setErrorAlertText("Erreur : aucun code à barre trouvé dans le fichier");
  //         return;
  //       }

  //       const parsedData = Object.entries(barcodeCount).map(([codeABarre, qte]) => ({
  //         codeABarre,
  //         qte,
  //       }));

  //       setBarcodeTableData(parsedData);
  //       setOpenSuccessAlert(true);
  //       setSuccessAlertText(`${parsedData.length} code(s) à barre importé(s) depuis ${file.name}`);
  //     } catch (err) {
  //       setOpenErrorAlert(true);
  //       setErrorAlertText("Erreur : impossible de lire le fichier Excel");
  //     }
  //   };

  //   reader.readAsArrayBuffer(file);
  //   // Reset input so the same file can be re-uploaded
  //   event.target.value = "";
  // };

  const handleExcelUpload = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  setExcelFileName(file.name);
  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert to array of arrays. raw:false returns each cell's *displayed*
      // text instead of the raw number, which avoids barcodes being corrupted
      // into scientific notation (e.g. 6.19E+12) or losing leading zeros.
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false, defval: "" });

      if (rows.length === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : le fichier Excel est vide");
        return;
      }

      // The official template's first row is a header ("Code à barre" /
      // "Quantité"). Only strip it when it actually looks like a header
      // (its quantity column isn't a usable number) so a file uploaded
      // without a header row doesn't silently lose its first data line.
      const firstRowQty = parseFloat(rows[0][1]);
      const hasHeaderRow = !(Number.isFinite(firstRowQty) && firstRowQty > 0);
      const dataRows = hasHeaderRow ? rows.slice(1) : rows;

      if (dataRows.length === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : le fichier Excel est vide ou ne contient que le titre");
        return;
      }

      // Sum quantities per barcode (column A = barcode, column B = qty)
      const barcodeMap = {};
      dataRows.forEach((row) => {
        const code = row[0] !== null && row[0] !== undefined ? String(row[0]).trim() : "";
        const qty = parseFloat(row[1]) || 0;

        if (code) {
          barcodeMap[code] = (barcodeMap[code] || 0) + qty;
        }
      });

      if (Object.keys(barcodeMap).length === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : aucun code à barre trouvé dans le fichier");
        return;
      }

      const parsedData = Object.entries(barcodeMap).map(([codeABarre, qte]) => ({
        codeABarre,
        qte,
      }));

      setBarcodeTableData(parsedData);
      setOpenSuccessAlert(true);
      setSuccessAlertText(`${parsedData.length} code(s) à barre importé(s) depuis ${file.name}`);
    } catch (err) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : impossible de lire le fichier Excel");
    }
  };

  reader.readAsArrayBuffer(file);
  event.target.value = "";
};

  // ── Barcode quantity inline edit ──────────────────────────────────────────
  const onChangeBarcodeQty = (codeABarre, newQty) => {
    setBarcodeTableData((prev) =>
      prev.map((item) =>
        item.codeABarre === codeABarre ? { ...item, qte: parseInt(newQty) || 0 } : item
      )
    );
  };

  useEffect(() => {
    dispatch(getAllTransporters());
    WarehouseService.getAllWarehouse(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
          setwarehousesDestination(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => console.log("error in getAllRealWarehouse", e));
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) { exist = true; break; }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [...oldArray, { value: element.id, label: element.name }]);
        }
      });
  }, [warehousesSource]);

  useEffect(() => {
    warehousesDestination &&
      warehousesDestination.map((element) => {
        let exist = false;
        if (allWarehouseDestination.length !== 0) {
          for (let index = 0; index < allWarehouseDestination.length; index++) {
            if (allWarehouseDestination[index].value === element?.id) { exist = true; break; }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseDestination((oldArray) => [...oldArray, { value: element.id, label: element.name }]);
        }
      });
  }, [warehousesDestination]);

  useEffect(() => {
    transporteurs &&
      transporteurs.map((element) => {
        let exist = false;
        if (allTransportors.length !== 0) {
          for (let index = 0; index < allTransportors.length; index++) {
            if (allTransportors[index].value === element?.id) { exist = true; break; }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllTransportors((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.firstName + " " + element.lastName },
          ]);
        }
      });
  }, [transporteurs]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenErrorAlert(false);
  };
  const onChangeDescriptionHandler = (event) => {
    noteEditedRef.current = event.target.value.trim() !== "";
    setTransfertNote(event.target.value);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSuccessAlert(false);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenInfoAlert(false);
  };
  // Note par défaut : "Transfert de {source} vers {destination} au date de {date limite}"
  const noteEditedRef = useRef(false);
  useEffect(() => {
    if (noteEditedRef.current) return;
    const nameOf = (options, id) => {
      const found = options.find((o) => o.value === id);
      return found ? found.label : "";
    };
    const sourceName = nameOf(allWarehouseSource, warehouseSourceId);
    const destinationName = nameOf(allWarehouseDestination, warehouseDestinationId);
    if (!sourceName || !destinationName) return;
    let note = `Transfert de ${sourceName} vers ${destinationName}`;
    if (date) {
      const d = new Date(date);
      if (!isNaN(d.getTime())) {
        note += ` au date de ${d.toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      }
    }
    setTransfertNote(note);
  }, [
    warehouseSourceId,
    warehouseDestinationId,
    date,
    allWarehouseSource,
    allWarehouseDestination,
  ]);

  const handleOnChangeDate = (event) => setDate(event.target.value);

  const onAddProductToList = () => {
    let name = null;
    let exist = false;
    let indexInDataTable;

    try {
      productMapById.forEach((element, index) => {
        if (element.id === product) { indexInDataTable = index; exist = true; throw "Break"; }
      });
    } catch (e) { if (e !== "Break") throw e; }

    try {
      allProducts.forEach((element) => {
        if (element.value === product) { name = element.label; throw "Break"; }
      });
    } catch (e) { if (e !== "Break") throw e; }

    if (amount > parseInt(qteWarehouseSource)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la quantité de ce produit est indisponible dans le dépot");
    } else if (amount === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la quantité doit etre sup a zero");
    } else {
      if (!exist && amount !== 0) {
        setProductMapById((prev) => [...prev, { id: product, quantity: amount }]);
        setProductTableData((prev) => [...prev, { id: product, qte: amount, productName: name }]);
      } else if (exist && amount !== 0) {
        let newState = update(productTableData, { [indexInDataTable]: { qte: { $set: amount } } });
        let newStateTwo = update(productMapById, { [indexInDataTable]: { qte: { $set: amount } } });
        setOpenInfoAlert(true);
        setInfoAlertText("Info : tu as actualisé la quantité de produit : " + name);
        setProductMapById(newStateTwo);
        setProductTableData(newState);
      }
    }
  };

  const handleNext = () => {
    if (activeStep === 0) {
      var deadLine = new Date(date);
      var today = new Date();

      if (warehouseSourceId === 0) {
        setOpenErrorAlert(true); setErrorAlertText("Erreur : le champ de dépot source est vide");
      } else if (warehouseDestinationId === 0) {
        setOpenErrorAlert(true); setErrorAlertText("Erreur : le champ de dépot destination est vide");
      } else if (transportorId === 0) {
        setOpenErrorAlert(true); setErrorAlertText("Erreur : le champ de transporteur est vide");
      } else if (warehouseSourceId === warehouseDestinationId) {
        setOpenErrorAlert(true); setErrorAlertText("Erreur : la destination et la source sont egaux");
      } else if (date === "") {
        setOpenErrorAlert(true); setErrorAlertText("Erreur : la date limite est vide");
      } else if (deadLine < today) {
        setOpenErrorAlert(true); setErrorAlertText("Erreur : la date limite est inferieur a la date d'aujourd'hui");
      } else if (transfertNote === "") {
        setOpenErrorAlert(true); setErrorAlertText("Erreur : la désignation est vide");
      } else {
        WarehouseService.getAllWarehouseById(getCurrentUserId(), warehouseSourceId)
          .then((response) => {
            setProductSelectPlaceHolder("Choisir..");
            setAllProducts([{}]);
            response.data.success.productStocks.map((element) => {
              setAllProducts((oldArray) => [
                ...oldArray,
                { value: element.id, label: element.product.name, customElements: { quantity: element.quantity } },
              ]);
            });
          })
          .catch((e) => console.log("error", e));

        setActiveStep((prev) => prev + 1);
      }
    } else if (activeStep === 1) {
      const hasManualProducts = productTableData.length > 0;
      const hasBarcodeProducts = barcodeTableData.length > 0;

      if (!hasManualProducts && !hasBarcodeProducts) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : aucun produit à transférer");
        return;
      }

      // Validate barcode quantities
      if (hasBarcodeProducts) {
        const invalidBarcode = barcodeTableData.find((item) => !item.qte || item.qte <= 0);
        if (invalidBarcode) {
          setOpenErrorAlert(true);
          setErrorAlertText(`Erreur : quantité invalide pour le code "${invalidBarcode.codeABarre}"`);
          return;
        }
      }

      setActiveStep((prev) => prev + 1);
    } else if (activeStep === 2) {
      // Build productTransaction hash from manual products
      let hash = {};
      productTableData.forEach((element) => {
        hash[element.id.toString()] = element.qte;
      });

      // Build barcodeTransaction hash from Excel-imported barcodes
      let barcodeHash = {};
      barcodeTableData.forEach((element) => {
        barcodeHash[element.codeABarre] = element.qte;
      });

      let warehouseTransfertModel = {
        deadline: date,
        description: transfertNote,
        idTransportor: transportorId,
        idWarhouseDestination: parseInt(warehouseDestinationId),
        idWarhouseSource: parseInt(warehouseSourceId),
        productTransaction: barcodeHash,
        userCreation: getCurrentUserId(),
      };

      startLoading();
      TransferService.addWarehouseTransfertAdminViaExcel(warehouseTransfertModel)
        .then((response) => {
          const notFound = response.data.notFoundBarcodes || [];
          const insufficient = response.data.insufficientStockBarcodes || [];

          if (response.data.success) {
            if (notFound.length > 0 || insufficient.length > 0) {
              setOpenInfoAlert(true);
              let message = "Transfert enregistré, mais certains codes ont été ignorés :";
              if (notFound.length > 0) {
                message += ` introuvables [${notFound.join(", ")}]`;
              }
              if (insufficient.length > 0) {
                message += ` indisponibles dans le dépôt source [${insufficient.join(", ")}]`;
              }
              setInfoAlertText(message);
            } else {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succès");
            }
            setActiveStep((prev) => prev + 1);
          } else if (Object.keys(response.data)[0] === "ref_error") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : ce réference existe déjà");
          } else {
            setOpenErrorAlert(true);
            let message = response.data.error || "Erreur : une erreur s'est produite";
            if (notFound.length > 0) {
              message += ` — codes introuvables : ${notFound.join(", ")}`;
            }
            if (insufficient.length > 0) {
              message += ` — stock insuffisant pour : ${insufficient.join(", ")}`;
            }
            setErrorAlertText(message);
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + error);
        })
        .finally(() => stopLoading());
    }
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleReset = () => {
    setActiveStep(0);
    setBarcodeTableData([]);
    setProductTableData([]);
    setProductMapById([]);
    setExcelFileName("");
  };

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption(); setWarehouseSourceId(selectedOptionn.value);
  };
  const onChangeSelectedWarehouseDestination = (selectedOptionn) => {
    setSelectedOptionTwo(); setWarehouseDestinationId(selectedOptionn.value);
  };
  const onChangeSelectedTransportor = (selectedOptionn) => {
    setSelectedOptionThree(); setTransportorId(selectedOptionn.value);
  };
  const onChangeSelectedProduct = (selectedOptionn) => {
    setSelectedOptionProduct();
    setProduct(selectedOptionn.value);
    setCurrentQteProductPurchase(selectedOptionn.customElements.quantity);
  };

  const manualProductColumns = [
    { dataField: "productName", text: "Libellé", headerAlign: "center" },
    { dataField: "qte", text: "Qte", align: "center", headerAlign: "center" },
  ];

  const barcodeColumns = [
    { dataField: "codeABarre", text: "Code à Barre", headerAlign: "center" },
    {
      dataField: "qte",
      text: "Quantité",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => (
        <input
          type="number"
          min="1"
          value={cell}
          className="form-control form-control-sm text-center"
          style={{ width: 80, margin: "auto" }}
          onChange={(e) => onChangeBarcodeQty(row.codeABarre, e.target.value)}
        />
      ),
    },
    {
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      isDummyField: true,
      formatter: (cell, row) => (
        <button
          title="Supprimer"
          className="btn btn-sm btn-outline-danger"
          onClick={() => onDeleteBarcode(row.codeABarre)}
        >
          <i className="fas fa-trash"></i>
        </button>
      ),
    },
  ];

  function handleTableChange({ productTableData }) { return productTableData; }

  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Dépôt source</label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedWarehouseSource}
                    options={allWarehouseSource}
                    placeholder="Choisir..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Dépôt destination</label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionTwo}
                    onChange={onChangeSelectedWarehouseDestination}
                    options={allWarehouseDestination}
                    placeholder="Choisir..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Transporteur</label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionThree}
                    onChange={onChangeSelectedTransportor}
                    options={allTransportors}
                    placeholder="Choisir..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Date limite</label>
                  <TextField
                    style={{ width: "100%" }}
                    className="col-sm-12"
                    variant="outlined"
                    value={date}
                    onChange={handleOnChangeDate}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue="date"
                    InputLabelProps={{ shrink: true }}
                    size="small"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="inputDescription" style={labelStyle}>
                    Note
                  </label>
                  <textarea
                    value={transfertNote}
                    placeholder="Saisir..."
                    onChange={onChangeDescriptionHandler}
                    id="inputDescription"
                    className="form-control"
                    rows={3}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case 1:
        return (
          <div>
            {/* ── Mode toggle ─────────────────────────────────────────── */}
            <div className="row mb-3">
              <div className="col-sm-12 d-flex flex-wrap justify-content-between align-items-center">
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Mode de saisie"
                >
                  {/* <button
                    type="button"
                    className={`btn ${importMode === "manual" ? "btn-dark" : "btn-outline-dark"}`}
                    onClick={() => setImportMode("manual")}
                  >
                    <i className="fas fa-hand-point-up mr-1"></i>
                    Saisie manuelle
                  </button> */}
                  <button
                    type="button"
                    className={`btn ${importMode === "excel" ? "btn-dark" : "btn-outline-dark"}`}
                    onClick={() => setImportMode("excel")}
                  >
                    <i className="fas fa-file-excel mr-1"></i>
                    Import Excel (Code à Barre)
                  </button>
                </div>
              </div>
            </div>

            {/* ── MANUAL MODE ─────────────────────────────────────────── */}
            {importMode === "manual" && (
              <>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Choisir le produit</label>
                      <Select
                        key="selectProduct"
                        closeMenuOnSelect={true}
                        components={animatedComponentsProduct}
                        defaultValue={"Choisir"}
                        onChange={onChangeSelectedProduct}
                        options={allProducts}
                        placeholder={"Choisir"}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Choisir la quantité ({currentQteProductPurchase})</label>
                      <input
                        onChange={handlerChangeQt}
                        type="number"
                        min="0"
                        id="inputClientCompany"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <button
                      style={{ marginBottom: 20 }}
                      className="btn btn-dark"
                      onClick={onAddProductToList}
                    >
                      <i className="fas fa-plus mr-1"></i>
                      Ajouter à la liste
                    </button>
                  </div>
                </div>
                {productTableData.length > 0 && (
                  <div className="row">
                    <div className="col-sm-12">
                      <ToolkitProvider
                        keyField="id"
                        data={productTableData}
                        columns={manualProductColumns}
                        onTableChange={handleTableChange}
                      >
                        {(props) => (
                          <div className="row">
                            <BootstrapTable
                              {...props.baseProps}
                              headerClasses="thead-light"
                              wrapperClasses="table-responsive w-100"
                              striped
                              hover
                              condensed
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* ── EXCEL / BARCODE MODE ─────────────────────────────────── */}
            {importMode === "excel" && (
              <>
                {/* Template download */}
                <div className="row mb-3">
                  <div className="col-sm-12 text-right">
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      onClick={onTelechargerModele}
                    >
                      <i className="fas fa-download mr-1"></i>
                      Télécharger le modèle
                    </button>
                  </div>
                </div>

                {/* Upload zone */}
                <div className="row mb-3">
                  <div className="col-sm-12">
                    <div
                      style={{
                        border: `2px dashed ${excelFileName ? "#1d6f42" : "#adb5bd"}`,
                        borderRadius: 8,
                        padding: "30px 20px",
                        textAlign: "center",
                        backgroundColor: excelFileName ? "#f1faf5" : "#f8f9fa",
                        cursor: "pointer",
                      }}
                      onClick={() => fileInputRef.current && fileInputRef.current.click()}
                    >
                      <i
                        className="fas fa-file-excel"
                        style={{ fontSize: 40, color: "#1d6f42", marginBottom: 10, display: "block" }}
                      ></i>
                      <p className="mb-1" style={{ fontWeight: 600 }}>
                        {excelFileName
                          ? `Fichier chargé : ${excelFileName}`
                          : "Cliquez pour sélectionner un fichier Excel (.xlsx, .xls, .csv)"}
                      </p>
                      <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                        Format attendu : colonne A = code à barre, colonne B = quantité, avec une
                        ligne d'en-tête. Téléchargez le modèle pour être sûr du format.
                      </p>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        style={{ display: "none" }}
                        onChange={handleExcelUpload}
                      />
                    </div>
                  </div>
                </div>

                {/* Summary badge */}
                {barcodeTableData.length > 0 && (
                  <div className="row mb-2 align-items-center">
                    <div className="col-sm-6">
                      <span className="badge badge-dark" style={{ fontSize: 14, padding: "6px 12px" }}>
                        <i className="fas fa-barcode mr-1"></i>
                        {barcodeTableData.length} code(s) à barre importé(s)
                      </span>
                    </div>
                    <div className="col-sm-6 text-right">
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => { setBarcodeTableData([]); setExcelFileName(""); }}
                      >
                        <i className="fas fa-times mr-1"></i>
                        Effacer tout
                      </button>
                    </div>
                  </div>
                )}

                {/* Barcode table */}
                {barcodeTableData.length > 0 && (
                  <div className="row">
                    <div className="col-sm-12">
                      <ToolkitProvider
                        keyField="codeABarre"
                        data={barcodeTableData}
                        columns={barcodeColumns}
                        onTableChange={handleTableChange}
                      >
                        {(props) => (
                          <div className="row">
                            <BootstrapTable
                              {...props.baseProps}
                              headerClasses="thead-light"
                              wrapperClasses="table-responsive w-100"
                              striped
                              hover
                              condensed
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                )}

                {barcodeTableData.length === 0 && (
                  <div className="row">
                    <div className="col-sm-12 text-center text-muted" style={{ padding: 20 }}>
                      <i className="fas fa-barcode fa-2x mb-2 d-block"></i>
                      Aucun code à barre importé. Veuillez sélectionner un fichier Excel.
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        );

      case 2:
        return (
          <div>
            <div className="alert alert-warning d-flex align-items-center" role="alert">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              Avant de cliquer sur terminer, vous devez être sûr de l'information entrée.
            </div>

            {/* Summary of what will be sent */}
            {productTableData.length > 0 && (
              <div className="row mb-2">
                <div className="col-sm-12">
                  <h6>
                    Produits (saisie manuelle)
                    <span className="badge badge-dark ml-2">{productTableData.length}</span>
                  </h6>
                  <ul className="list-group" style={{ maxHeight: 320, overflowY: "auto" }}>
                    {productTableData.map((p) => (
                      <li key={p.id} className="list-group-item d-flex justify-content-between">
                        <span>{p.productName}</span>
                        <span className="badge badge-dark badge-pill">{p.qte}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {barcodeTableData.length > 0 && (
              <div className="row mb-2">
                <div className="col-sm-12">
                  <h6>
                    Codes à barre (import Excel)
                    <span className="badge badge-dark ml-2">{barcodeTableData.length}</span>
                  </h6>
                  <ul className="list-group" style={{ maxHeight: 320, overflowY: "auto" }}>
                    {barcodeTableData.map((b) => (
                      <li key={b.codeABarre} className="list-group-item d-flex justify-content-between align-items-center">
                        <span>
                          <i className="fas fa-barcode mr-2 text-muted"></i>
                          {b.codeABarre}
                        </span>
                        <span className="badge badge-dark badge-pill">{b.qte}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        );

      default:
        return "Unknown step";
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <h4 className="mb-1">
            <i className="fas fa-file-excel mr-2"></i>Transfert via Excel
          </h4>
          <small className="text-muted">
            Créez un transfert entre dépôts en important vos codes à barre depuis un
            fichier Excel
          </small>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-outline card-dark" style={cardStyle}>
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                {activeStep === steps.length ? (
                  <div>
                    <div className="card-body text-center py-5">
                      <i
                        className="fas fa-check-circle fa-3x mb-3 d-block"
                        style={{ color: "#28a745" }}
                      ></i>
                      <h5>La demande de transfert est faite</h5>
                    </div>
                    <div className="card-footer text-right">
                      <button className="btn btn-dark" onClick={handleReset}>
                        <i className="fas fa-undo mr-1"></i>
                        Nouveau transfert
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="card-body">{getStepContent(activeStep)}</div>
                    <div className="card-footer d-flex justify-content-between">
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-outline-secondary"
                        onClick={handleBack}
                      >
                        <i className="fas fa-arrow-left mr-1"></i>
                        Précédent
                      </button>
                      <button className="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1 ? (
                          <>
                            <i className="fas fa-check mr-1"></i>Terminer
                          </>
                        ) : (
                          <>
                            Suivant<i className="fas fa-arrow-right ml-1"></i>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar open={openInfoAlert} autoHideDuration={2000} onClose={handleInfoClose} anchorOrigin={{ vertical: "bottom", horizontal: "left" }}>
        <Alert onClose={handleInfoClose} severity="info">{infoAlertText}</Alert>
      </Snackbar>
      <Snackbar open={openSuccessAlert} autoHideDuration={2000} onClose={handleSuccessClose} anchorOrigin={{ vertical: "bottom", horizontal: "left" }}>
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">{successAlertText}</Alert>
      </Snackbar>
      <Snackbar open={openErrorAlert} autoHideDuration={2000} onClose={handleEroorClose} anchorOrigin={{ vertical: "bottom", horizontal: "left" }}>
        <Alert variant="filled" onClose={handleEroorClose} severity="error">{errorAlertText}</Alert>
      </Snackbar>
    </div>
  );
};

export default withLoader(WarehouseTransfertExcel);